import { useApp } from '@context/AppContext';
import { useSquiggle } from './useSquiggle';

/**
 * Brief overlay (4 seconds, auto-advanced by useSquiggle hook).
 * Shows the completed transformation with attribution.
 */
export default function SquigglePairReveal() {
  const { state } = useApp();
  const { game } = state;
  // Hook must be active here so the pairReveal → next pair timer fires
  useSquiggle();

  const pairIndex = game.currentPairIndex ?? 0;
  const snapshot = game.snapshots?.[pairIndex];
  const pair = game.pairs?.[pairIndex];
  const totalPairs = game.pairs?.length || 0;
  const isLastPair = pairIndex >= totalPairs - 1;

  const squigglerName = snapshot?.squigglerNickname || 'Someone';
  const transformerName = snapshot?.transformerNickname || 'Someone';

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      {/* Attribution */}
      <h2 className="text-xl font-bold text-white font-display mb-2 text-center">
        {transformerName} turned {squigglerName}&apos;s squiggle into...
      </h2>

      {/* Completed snapshot */}
      {snapshot?.completed && (
        <div className="bg-white rounded-2xl overflow-hidden shadow-xl max-w-sm w-full animate-[fadeIn_0.5s_ease-out]">
          <img
            src={snapshot.completed}
            alt={`${transformerName}'s transformation`}
            className="w-full aspect-[4/3] object-cover bg-canvas"
          />
        </div>
      )}

      {/* Progress indicator */}
      <div className="mt-4 flex items-center gap-2">
        {Array.from({ length: totalPairs }).map((_, idx) => (
          <div
            key={idx}
            className={`w-2.5 h-2.5 rounded-full transition-colors ${
              idx <= pairIndex ? 'bg-amber' : 'bg-white/30'
            }`}
          />
        ))}
      </div>

      {/* Next up hint */}
      <p className="mt-3 text-sm text-white/60 font-display">
        {isLastPair ? 'Heading to the gallery...' : 'Next pair coming up...'}
      </p>
    </div>
  );
}
